module.exports = __webpack_public_path__ + "img/学习压力测试.d57d3b7b.png";